export default __webpack_public_path__ + "static/media/personFlip.4d09ec6a.png";